<template>
    <MenuLayout :settingsMode="true"></MenuLayout>
</template>
<script>

export default {
  name: 'MenuLayoutWidgets',
  components: {
    'MenuLayout': () => import('./MenuLayout')
  }
}
</script>

